<script setup lang="ts">
import type { IAiChatInsuranceProduct } from './types'
import { localizedField, formatPeriodMonths, formatAmountRange } from '../utils'

const props = defineProps<{ item: IAiChatInsuranceProduct }>()
const { t, locale } = useI18n()

const title = computed(() => localizedField(props.item.title, locale.value))
const company = computed(() => localizedField(props.item.company, locale.value))
const insuranceType = computed(() => localizedField(props.item.insurance_type, locale.value))

const premium = computed(() => formatAmountRange(props.item.premium_from, props.item.premium_to, t))
const coverage = computed(() =>
  formatAmountRange(props.item.coverage_min, props.item.coverage_max, t)
)
const duration = computed(() => {
  const months = props.item.duration_max ?? props.item.duration_min
  return formatPeriodMonths(months, t)
})
</script>

<template>
  <NuxtLink :to="item.url" class="AiCard group">
    <div class="min-w-0">
      <div class="truncate text-sm font-semibold text-gray-900 group-hover:text-blue-600">
        {{ title }}
      </div>
      <div class="SecondaryTextHeadings">{{ insuranceType }}</div>
      <div class="text-xs text-gray-500">{{ company }}</div>
    </div>
    <div
      v-if="premium || coverage || duration"
      class="mt-2 grid grid-cols-3 gap-x-3 gap-y-2"
    >
      <div v-if="premium">
        <div class="SecondaryTextHeadings">{{ $t('common.premium') }}</div>
        <div class="text-sm font-semibold">{{ premium }}</div>
      </div>
      <div v-if="coverage">
        <div class="SecondaryTextHeadings">{{ $t('common.coverage') }}</div>
        <div class="text-sm font-semibold">{{ coverage }}</div>
      </div>
      <div v-if="duration">
        <div class="SecondaryTextHeadings">{{ $t('common.term') }}</div>
        <div class="text-sm font-semibold">{{ duration }}</div>
      </div>
    </div>
  </NuxtLink>
</template>
